import { render, staticRenderFns } from "./adjust.vue?vue&type=template&id=bc80ddac&scoped=true"
import script from "./adjust.vue?vue&type=script&lang=js"
export * from "./adjust.vue?vue&type=script&lang=js"
import style0 from "./adjust.vue?vue&type=style&index=0&id=bc80ddac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80ddac",
  null
  
)

export default component.exports